import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../reactRoute/RouteConstants';
import { useUser } from '../../../UserContext'; // Import useUser hook

const ConditionModal = () => {
    const { userType, setUserType } = useUser(); // Get userType and setUserType from context
    const navigate = useNavigate();
    const [conditionModal, setConditionModal] = useState(!userType);

    const handleSelectUserType = (type) => {
        setUserType(type);
        setConditionModal(false);
        if (type === 'consumer') {
            navigate(ROUTES.customerHome);
        } else {
            navigate(ROUTES.djHome); // Change this to the appropriate DJ home route
        }
    };

    return (
        <>
            {conditionModal &&
                <div className='fixed inset-0 z-50 bg-[#00000040] flex items-center justify-center'>
                    <div className="flex items-center bg-[#FFF] rounded-[16px] max-sm:m-[20px] flex-col sm:p-[48px] p-[24px] sm:gap-[36px] gap-[24px]">
                        <div className="flex items-center flex-col gap-[16px]">
                            <h2 className='sm:text-[36px] font-[600] text-center text-[28px]'>
                                Choose User Type
                            </h2>
                            <p className='text-[#475467] sm:text-[20px] text-[16px] max-w-[536px] text-center'>
                                Choose your user type to tailor the experience and access the most relevant features.
                            </p>
                        </div>
                        <div className="flex items-center gap-[24px]">
                            <button onClick={() => handleSelectUserType('consumer')} className='px-[16px] py-[10px] rounded-[10px] bg-[#F02E49] text-[#FFF] text-[18px]'>
                                Consumer
                            </button>
                            <button onClick={() => handleSelectUserType('dj')} className='px-[16px] py-[10px] rounded-[10px] bg-[#7F56D9] text-[#FFF] text-[18px]'>
                                DJs
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default ConditionModal;
